import BodyText from "components/Typography/BodyText"
import { TabsContext } from "components/EvtKit/tabs/Tabs"

import clsx from "clsx"
import { memo, useCallback, useContext, useEffect, useMemo } from "react"
import styled from "styled-components"

const TabsTriggerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const TabsTriggerButton = styled.button`
  height: 100%;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;

  &.disabled {
    cursor: default;
  }
`

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export interface TabsTriggerProps {
  label: string
  numberLabel: string
  triggerId: string
  disabled?: boolean
  isUpdate?: boolean
}

const CreatePlanTabTriggerButton = (props: TabsTriggerProps) => {
  const { label, numberLabel, triggerId, disabled = false, isUpdate = false } = props

  const { onActiveTabIdChange, defaultActiveTabId, activeTabId } = useContext(TabsContext)

  const handleTrigger = useCallback(() => {
    if (disabled) return

    onActiveTabIdChange(triggerId)
  }, [triggerId, onActiveTabIdChange, disabled])

  useEffect(() => {
    if (!activeTabId && defaultActiveTabId) {
      onActiveTabIdChange(defaultActiveTabId)
    }
  }, [])

  const isActive = activeTabId === triggerId

  const labelColor = useMemo(() => {
    if (disabled) return "gray-medium"

    if (isUpdate) return "primary-dark"

    return isActive ? "primary-dark" : "gray-dark"
  }, [isActive, disabled])

  return (
    <TabsTriggerContainer>
      <TabsTriggerButton onClick={handleTrigger} className={clsx({ disabled })}>
        <TextContainer>
          <BodyText size="large" weight="semi-bold" color={labelColor}>
            {numberLabel}
          </BodyText>
          <BodyText size="large" weight="semi-bold" color={labelColor} link={isActive}>
            {label}
          </BodyText>
        </TextContainer>
      </TabsTriggerButton>
    </TabsTriggerContainer>
  )
}

export default memo(CreatePlanTabTriggerButton)
